import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import FixedPlugin from "../views/RightSideBar/rightSideBar.js";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import PaymentSidebar from "components/Sidebar/PaymentSidebar.js";
import CustomerHeader from "components/Headers/CustomerHeader.js";

import routes from "routes.js";

import { Container, Col } from "reactstrap";

// Layout for payment-lead customers (payment_tran = true). Same header as the
// customer view, but a trimmed sidebar/tab set driven by the "/payment" routes.
const Payment = (props) => {
  const url = window.location.href;
  const pathParts = new URL(url).pathname.split("/");
  const cid = pathParts[3];
  const lid = pathParts[4];

  const mainContent = React.useRef(null);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/payment") {
        return <Route path={prop.path} element={prop.component} key={key} exact />;
      }
      return null;
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <PaymentSidebar
        {...props}
        cid={cid}
        lid={lid}
        routes={routes}
        logo={{
          innerLink: "/admin/lead-list",
          imgSrc: require("../assets/img/brand/logo.png"),
          imgAlt: "...",
        }}
      />

      <div className="main-content" ref={mainContent}>
        <AdminNavbar {...props} brandText={getBrandText(props?.location?.pathname)} />

        <CustomerHeader cid={cid} lid={lid} />

        <Container className="mt--7" fluid>
          <Col className="order-xl-1" xl="12" style={{ paddingLeft: "0" }}>
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/admin/lead-list" replace />} />
            </Routes>
          </Col>

          <FixedPlugin />
        </Container>

        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Payment;
